export const WELCOME_TEXT =
  "Hi! I’m your SG Office AI assistant 👋\n\nAsk me naturally — I can help you find products, compare options, guide checkout, track orders, and handle bulk quote requests.";

export const STARTER_PROMPTS = [
  { label: "Find products for my office", type: "prompt" },
  { label: "I need a bulk quote", type: "prompt" },
  { label: "Track my order", type: "prompt" },
  { label: "Delivery across UAE?", type: "prompt" },
];

export const FALLBACK_OPTIONS = [
  { label: "Browse products", type: "route", path: "/products" },
  { label: "Request quote", type: "route", path: "/quote" },
  { label: "Track order", type: "route", path: "/order-tracking" },
  {
    label: "WhatsApp support",
    type: "link",
    url: "https://wa.me/971509348007?text=Hi%2C%20I%20need%20help%20with%20SG%20Office%20Supplies.",
  },
];
